(function () {
  function initFlightPath() {
    var root = document.getElementById('scroll-flight-path');
    if (!root || root.dataset.flightInit) return;
    root.dataset.flightInit = 'true';

    var fill = root.querySelector('[data-flight-fill]');
    var jet = root.querySelector('[data-flight-jet]');
    var markersContainer = root.querySelector('[data-flight-markers]');
    var track = root.querySelector('.scroll-flight-path__track');

    if (!fill || !jet || !markersContainer || !track) return;

    var markers = [];

    function buildMarkers() {
      markersContainer.innerHTML = '';
      markers = [];

      var main = document.getElementById('MainContent') || document.body;
      var sections = main.querySelectorAll(':scope > .shopify-section');
      if (!sections.length) return;

      var docHeight = document.documentElement.scrollHeight - window.innerHeight;
      if (docHeight <= 0) return;

      sections.forEach(function (section, index) {
        if (index === 0) return; // skip the very first boundary (top of page)
        var scrollPercent = section.offsetTop / docHeight;
        if (scrollPercent <= 0 || scrollPercent >= 1) return;

        var marker = document.createElement('div');
        marker.className = 'scroll-flight-path__marker';
        marker.style.top = (scrollPercent * 100) + '%';
        markersContainer.appendChild(marker);
        markers.push({ el: marker, percent: scrollPercent });
      });
    }

    function update() {
      var docHeight = document.documentElement.scrollHeight - window.innerHeight;
      var progress = docHeight > 0 ? Math.min(Math.max(window.scrollY / docHeight, 0), 1) : 0;
      var trackHeight = track.offsetHeight;

      fill.style.height = (progress * 100) + '%';
      jet.style.top = (progress * trackHeight) + 'px';

      markers.forEach(function (marker) {
        if (progress >= marker.percent) {
          marker.el.classList.add('is-passed');
        } else {
          marker.el.classList.remove('is-passed');
        }
      });
    }

    var lastScrollY = window.scrollY;

    function updateDirection() {
      var currentY = window.scrollY;
      var delta = currentY - lastScrollY;
      if (Math.abs(delta) < 2) return;
      root.classList.toggle('scroll-flight-path--ascending', delta < 0);
      lastScrollY = currentY;
    }

    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        updateDirection();
        update();
        ticking = false;
      });
    }

    buildMarkers();
    update();

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () {
      buildMarkers();
      update();
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initFlightPath();
  });

  document.addEventListener('shopify:section:load', function () {
    initFlightPath();
  });
})();